import {NgModule} from '@angular/core';
import {LoginComponent} from './auth/login/login.component';
import {LogoutComponent} from './auth/login/logout.component';
import {ForgotPasswordComponent} from './auth/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './auth/reset-password/reset-password.component';
import {HasPermissionDirective} from './auth/rbac/has-permission.directive';
import {LoginService} from './auth/login/login.service';
import {AuthService} from './auth/auth.service';
import {CmSharedModule} from './shared-module';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {AuthGuard} from './auth/guards/auth-guard.service';
import {RoleCanActivate} from './auth/rbac/role-can-activate.service';
import {RoleCanLoad} from './auth/rbac/role-can-load.service';
import {RolePermissionGuard} from './auth/guards/role-permission-guard.service';
import {RolePermissionService} from './auth/rbac/role-permission.service';
@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HasPermissionDirective
  ],
  imports: [
    CmSharedModule,
    FormsModule,
    RouterModule,
  ],
  providers: [
    LoginService,
    AuthService,
    AuthGuard,
    RoleCanActivate,
    RoleCanLoad,
    RolePermissionGuard,
    RolePermissionService,
  ],
  exports: [
    LoginComponent,
    LogoutComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HasPermissionDirective,
  ],
  entryComponents: []
})
export class AuthModule {

}
